'use client';

interface MessageBubbleProps {
  content: string;
  isUser: boolean;
  suggestions?: string[];
  onSuggestionClick?: (suggestion: string) => void;
}

export default function MessageBubble({
  content,
  isUser,
  suggestions = [],
  onSuggestionClick
}: MessageBubbleProps) {
  // 用户消息 - 右侧对齐
  if (isUser) {
    return (
      <div className="flex justify-end mb-6 animate-slide-up">
        <div 
          className="max-w-[75%] px-5 py-3.5 bg-[#2A2A2A] 
                     rounded-[20px_20px_4px_20px] 
                     text-white text-[15px] leading-relaxed shadow-xs"
        >
          {content}
        </div>
      </div>
    );
  }

  // AI消息 - 左侧对齐
  return (
    <div className="flex justify-start mb-8 animate-slide-up group">
      <div className="max-w-[85%]">
        {/* 头像/图标 (可选) */}
        
        {/* AI回复文本 */}
        <div className="text-white/90 text-[15px] leading-relaxed whitespace-pre-wrap font-light tracking-wide">
          {content}
        </div>
        
        {/* 建议问题 - 药丸按钮样式 */}
        {suggestions.length > 0 && (
          <div className="flex flex-wrap gap-2.5 mt-5 pl-1">
            {suggestions.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => onSuggestionClick?.(suggestion)}
                className="inline-flex items-center px-4 py-2 rounded-full 
                           bg-white/4 border border-white/8
                           text-[13px] text-white/70 hover:text-white 
                           hover:bg-white/8 hover:border-primary-purple/30
                           transition-all duration-200"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-linear-to-r from-primary-purple to-primary-pink mr-2.5 opacity-70" />
                {suggestion}
              </button>
            ))}
          </div>
        )}
        
        {/* 工具栏 (悬停显示) */}
        <div className="flex gap-3 mt-3 pl-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
           <button className="text-xs text-white/40 hover:text-white transition-colors flex items-center gap-1">
             <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
               <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
               <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
             </svg>
             复制
           </button>
           <button className="text-xs text-white/40 hover:text-white transition-colors flex items-center gap-1">
             <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
               <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>
             </svg>
             赞
           </button>
           <button className="text-xs text-white/40 hover:text-white transition-colors flex items-center gap-1">
             <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
               <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
               <polyline points="7 10 12 15 17 10"></polyline>
               <line x1="12" y1="15" x2="12" y2="3"></line>
             </svg>
             下载
           </button>
        </div>
      </div>
    </div>
  );
}
